import { Check, PersonAddAlt1 } from "@mui/icons-material";
import { KeyDriveSelect } from "../../../../components/KeydriveComponents/Selects/KeyDriveSelect";
import { User } from "../../../../model/OrganizationModel";
import { Box, SelectChangeEvent } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import PrivilegeCardListing from "./PrivilegeCardListing";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { StatePrivilegesTypes } from "../WorkSpacePermissions";
import usePrivilegeName from "../../../../functions/hooks/usePrivilegeName";
import { KeyDrivePageContainer } from "../../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";

interface IPrivilegeStateEditingUser {
    editPermission: () => void;
    organizationUsers: User[];
    handleUser(e: SelectChangeEvent): void;
    newUserSearch: string;
    setPermissionType: (set: number) => void;
    userId: string;
    permissionType: number;
    setNewUserSearch: (set: string) => void;
    privilegesState: {
        state: StatePrivilegesTypes;
        id: string;
        permissionType: number;
    },
    backBtn:() => void;
    isItemPage: boolean;
}

function PrivilegeStateEditingUser({
    editPermission,
    organizationUsers,
    handleUser,
    newUserSearch,
    setPermissionType,
    userId,
    permissionType,
    setNewUserSearch,
    privilegesState,
    backBtn,
    isItemPage
}: IPrivilegeStateEditingUser) {

    const { t } = useTranslation();
    const { privilegeName } = usePrivilegeName(permissionType);
    useEffect(() => {
        setPermissionType(privilegesState.permissionType);
        setNewUserSearch(privilegesState.id);
    }, [userId]);

    return (
        <KeyDrivePageContainer
            icon={<PersonAddAlt1 fontSize='large' sx={{ color: "#22638D" }} />}
            title={t("Privileges.ModifyUser")}
            subtitle={""}
            actions={<KeyDrivePrimaryButton
                TextComponent={KeyDriveBodyMin}
                TextComponentProps={{
                    color: "",
                    needBold: false,
                    needEllipses: false,
                    text: t("Privileges.Edit")!
                }}
                startIcon={<Check />}
                onClick={editPermission}
            />}
            onClickBtnBack={(e)=> backBtn()}>
            <KeyDriveSelect<User>
                renderItem={(item) => (
                    <Box display="flex" alignItems="center">
                        {item.name}
                        <Box ml="4px">
                            <KeyDriveBodyMin
                                text={`(${item.login})`}
                                color="#2D2D2D"
                                needBold={false}
                                needEllipses={false}
                                opacityParams={{
                                    needOpacity: true,
                                    opacityLevel: "0.5"
                                }}
                            />
                        </Box>
                    </Box>
                )}
                keyExtract={(item) => item.id}
                items={organizationUsers}
                onChange={handleUser}
                value={newUserSearch}
                label={t("AdminConsole.User")}
                needFullWidth
            />
            <Box
                marginTop="30px"
                marginBottom="15px"
            >
                <KeyDriveBodyMax
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text="Privilégios"
                />
                <KeyDriveBodyMin
                    color="#2d2d2d"
                    needBold={false}
                    needEllipses={false}
                    text={`${t("Privileges.DefineNewPrivilege")} ${privilegeName}`}
                />
            </Box>
            <PrivilegeCardListing
                setPermissionType={setPermissionType}
                permissionType={permissionType}
                isItemPrivilege={isItemPage}
            />
        </KeyDrivePageContainer>
    );
}

export default PrivilegeStateEditingUser;